import logo from './logo.svg';
import './App.css';

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Services from "./components/Services";
import Song from "./components/Song";
import Pooja from "./components/Pooja";
import Application from "./components/Application";
import Contact from "./components/Contact";
import Foter from "./components/Foter";

function App() {
  return (
    <div className="App">
      <Navbar />
      
     

      <div id="home">
        <HeroSection />
      </div>

      <div id="about">
        <About />
      </div>

      <div id="services">
        <Services />
      </div>

      <div id="music">
        <Song />
      </div>

      
      <div id="products">
        <Pooja />
      </div>

      <Application/>

      <div id="contact">
        <Contact />
      </div>

      <Foter />
    </div>
  );
}

export default App;